import { JobData, SortOption } from '../types';
import { searchCompanyNames, searchJobTitles} from '../lib/supabase';

// Get company name suggestions based on search term (optimized for large datasets)
export const getCompanyNameSuggestions = async (searchTerm: string, limit: number = 10): Promise<string[]> => {
  try {
   return await searchCompanyNames(searchTerm, limit);
  } catch (error) {
    throw error;
  }
};

// Get job title suggestions based on search term (optimized for large datasets)
export const getJobTitleSuggestions = async (searchTerm: string, limit: number = 10): Promise<string[]> => {
  try {
    return await searchJobTitles(searchTerm, limit);
  } catch (error) {
    throw error;
  }
};

// Sort jobs based on the selected option and direction
export const sortJobs = (jobs: JobData[], sortBy: SortOption, direction: 'asc' | 'desc'): JobData[] => {
  return [...jobs].sort((a, b) => {
    let comparison = 0;
    
    switch (sortBy) {
      case 'companyName':
        comparison = a.companyName.localeCompare(b.companyName);
        break;
      case 'jobTitle':
        comparison = a.jobTitle.localeCompare(b.jobTitle);
        break;
      case 'baseSalary':
        comparison = a.baseSalary - b.baseSalary;
        break;
      case 'year':
        comparison = a.year - b.year;
        break;
      default:
        return 0;
    }
    
    return direction === 'desc' ? -comparison : comparison;
  });
};